import type { ReactNode } from 'react';

import { cn } from '@/shared/lib/utils';

export interface DialogFooterProps {
  children: ReactNode;
  className?: string;
}

/**
 * Sdílená patička dialogu – pruh s odsazením, horní linkou a podkladem `--phx-surface-2`. Obsah (poznámka,
 * akční tlačítka) si dodává konzument; layout zařídí typicky `flex` se `spacer`em. Sjednocuje vzhled patičky
 * mezi vestavěným {@link import('./Dialog').Dialog} a vlastními `chromeless` dialogy.
 */
export function DialogFooter({ children, className }: DialogFooterProps) {
  return (
    <footer
      className={cn(
        'phx-dialog-foot border-phx-border bg-phx-surface-2 px-phx-6 py-phx-4 flex w-full shrink-0 items-center space-x-2 border-t',
        className
      )}
    >
      {children}
    </footer>
  );
}
